import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FmntsFormFieldModule } from '@fmnts/components/form-field';
import { FmntsIconsModule } from '@fmnts/components/icons';
import { ErrorMessagePipe } from '@fmnts/declarative-forms';
import { I18nModule } from '@fmnts/i18n';

/**
 * A module that can be imported in declarative-form field components.
 */
@NgModule({
  exports: [
    CommonModule,
    I18nModule,
    FormsModule,
    FmntsFormFieldModule,
    FmntsIconsModule,
    ErrorMessagePipe,
  ],
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    FmntsFormFieldModule,
    FmntsIconsModule,
    ErrorMessagePipe,
  ],
})
export class SharedDeclarativeCampaignFormsModule {}
